export { default as GDMDialogActions } from './GDMDialogActions';

export type { GDMDialogActionsComponent, GDMDialogActionsProps } from './GDMDialogActions.type';
